import { useState, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";

/* room1 마당 */

function Room1() {

  const [showPoolPopover, setShowPoolPopover] = useState(false);
  const [PoolPopoverText, setPoolPopoverText] = useState('');
  const PoolRef = useRef(null);

  const handlePoolClick = () => {
    setPoolPopoverText("낙엽이 떠다닌다");
    setShowPoolPopover(true);
    setTimeout(() => setShowPoolPopover(false), 2000);
};

  const [showSunbedPopover, setShowSunbedPopover] = useState(false);
  const [SunbedPopoverText, setSunbedPopoverText] = useState('');
  const SunbedRef = useRef(null);

  const handleSunbedClick = () => {
  setSunbedPopoverText("색이 바래져 있다");
  setShowSunbedPopover(true);
  setTimeout(() => setShowSunbedPopover(false), 2000);
};
  
  return (
 
      <div
        className="d-flex align-content-center" 
        style={{height: 'calc(100vh - 200px)',
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'center',
        gap: '15vw',
        marginTop: '-10vh',
        padding: '0 2vw',
         }}>
        <button
        ref={PoolRef}
        type="button"
        className="btn btn-secondary"
        onClick={handlePoolClick}
          style={{
            left: 0,
            borderRadius: 0,
            width: '45vw',
            height: '20vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >수영장</button>

          <button
          ref={SunbedRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleSunbedClick}
          style={{
            width: '18vw',
            height: '7vh',
            marginTop: '-5vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: "70%",
          }}
          >선베드</button>

          {PoolRef.current && (
            <Overlay target={PoolRef} show={showPoolPopover} placement="top">
              {(props) => (
                <Popover {...props}>
                  <Popover.Body>{PoolPopoverText}</Popover.Body>
                </Popover>
              )}
            </Overlay>
          )}

          {SunbedRef.current && (
            <Overlay target={SunbedRef} show={showSunbedPopover} placement="top">
              {(props) => (
                <Popover {...props}>
                  <Popover.Body>{SunbedPopoverText}</Popover.Body>
                </Popover>
              )}
            </Overlay>
          )}


          </div>

          
  );
}


export default Room1;

